import { createAction, props } from '@ngrx/store';

import { EnquiryConfig } from '@lockton-apps/shared/interfaces';

export enum NewEnquiryActionTypes {
  Init = '[NewEnquiry Page] Initialised',
  FormSubmitted = '[NewEnquiry Page] Form Submitted',
  FormSubmitCancelled = '[NewEnquiry Page] Form Submit Cancelled',
}

export const NewEnquiryActions = {
  init: createAction(NewEnquiryActionTypes.Init),
  formSubmitted: createAction(
    NewEnquiryActionTypes.FormSubmitted,
    props<{
      enquiryConfiguration: Omit<
        EnquiryConfig,
        'portalId' | 'clientId' | 'type'
      > & { portalId: string | undefined };
    }>()
  ),
  formSubmitCancelled: createAction(NewEnquiryActionTypes.FormSubmitCancelled),
};
